import styled from '@emotion/styled';
import { breakpoints } from '~/theme';

export const StyledFacetsOverlay = styled.div<{ showOnDesktop?: boolean }>(({ showOnDesktop, theme }) => ({
	display: 'block',
	paddingTop: theme.space[2],

	[breakpoints.lg]: {
		display: !showOnDesktop ? 'none' : 'block',
	},
}));
